import dayjs from "dayjs";
import React, {useState} from "react";
import CreateEventForm from "../forms/CreateEventForm.jsx";
import {useDeleteEvent} from "./useDeleteEvent.js";
import {useUser} from "../hooks/useUser.js";
import Button from "../ui/Button.jsx";

import utc from 'dayjs/plugin/utc';
dayjs.extend(utc);

function EventBox({ event }) {
    const [showDetails, setShowDetails] = useState(false);
    const [showConfirmDelete, setShowConfirmDelete] = useState(false);
    const [showForm, setShowForm] = useState(false);
    const { isDeleting, deleteEvent } = useDeleteEvent();
    const { isLoading, user, isAuthenticated } = useUser();

    const toggleDetails = () => {
        // If form is open, don't allow collapsing
        if (showForm) return;
        setShowDetails((prev) => !prev);
    };

    return (
        <div
            onClick={toggleDetails}
            className="bg-white p-4  mb-4 cursor-pointer
            transition"
        >
            <p className="text-sm font-bold text-pink-500">
                {dayjs.utc(event.startDatetime).local().format("DD MMM YYYY, HH:mm")}
            </p>
            <p className="text-xl font-bold ">{event.name}</p>
            {event.venue && (
                <p className="text-sm text-gray-500 font-medium">
                    {event.venue} ({event.city})
                </p>
            )}

            {/*{showDetails && (*/}
            {true && (
                <div className="pt-4 space-y-2">
                    {event.description && (
                        <p className="text-sm text-gray-700">{event.description}</p>
                    )}
                    
                    <div className="flex flex-wrap gap-3 mt-4 justify-left">
                        {event.ticketsUrl && (
                            <Button size="small" onClick={() => window.open(event.ticketsUrl, "_blank")}>
                                🎟 Tickets
                            </Button>
                        )}
                        <Button size="small"
                                onClick={(e) => {
                                    e.stopPropagation(); // Prevent box toggle
                                    const shareUrl = window.location.origin + `/events/${event.id}`;
                                    const shareText = `Check out this party: ${event.name} on ${dayjs.utc(event.startDatetime).local().format("DD MMM YYYY - HH:mm")} in ${event.city}, ${event.state}`;
                                    if (navigator.share) {
                                        navigator.share({ title: event.name, text: shareText, url: shareUrl }).catch(console.error);
                                    } else {
                                        navigator.clipboard.writeText(shareUrl)
                                            .then(() => alert("Link copied to clipboard!"))
                                            .catch(() => alert("Could not copy the link"));
                                    }
                                }}>
                            📤 Share
                        </Button>
                    </div>

                    {isAuthenticated && user.role === 'admin' && (
                        <div className="flex flex-wrap gap-4 mt-4 justify-center">
                            <Button size="small" onClick={(e) => { e.stopPropagation(); setShowForm((s) => !s); }}>
                                Edit Event
                            </Button>
                            <Button size="small" onClick={(e) => { e.stopPropagation(); setShowConfirmDelete((s) => !s); }} disabled={isDeleting}>
                                Delete Event Id {event.id}
                            </Button>
                        </div>
                    )}

                    {showConfirmDelete && (
                        <div className="mt-2">
                            <p>Are you sure you want to delete this event permanently?</p>
                            <Button size="small" className="!bg-red-400" onClick={() => deleteEvent(event.id)} disabled={isDeleting}>
                                Confirm Deletion
                            </Button>
                        </div>
                    )}

                    {showForm && <CreateEventForm eventToEdit={event} />}
                </div>
            )}
            <div className="h-px w-full bg-pink-600 mt-9" />

        </div>
    );
}


export default EventBox;